<template lang="pug">
  v-select(
    :value="value"
    @input="$emit('change', $event)"
    :items="tags"
    item-text="name"
    item-value="id"
    label="Метки"
    chips multiple rounded filled
  )
    template(v-slot:selection="{ item }")
      v-chip(
        :color="item.color"
        :dark="invertColor(item.color)"
      ) {{ item.name }}
</template>

<script>
import { invertColor } from '@/utils/color-functions';

export default {
  name: 'TagSelect',
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    loadTags: {
      type: Boolean,
      default: true,
    },
    initialTags: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      tags: [],
    };
  },
  watch: {
    initialTags(val) {
      this.tags = val;
    },
  },
  mounted() {
    if (this.loadTags) {
      this.getTagList();
    } else {
      this.tags = this.initialTags;
    }
  },
  methods: {
    invertColor,
    getTagList() {
      this.$rHandler(
        this.$api.tag.index(),
        (r) => {
          this.tags = r.data.data;
        },
      );
    },
  },
};
</script>

<style scoped>

</style>
